<template>
  <div :class="componentClasses">
    <Icon :icon="priorityIcon" />
  </div>
</template>

<script setup>
import { computed } from 'vue';
import { Icon } from '@stakeui';

const props = defineProps({
  priority: {
    type: Number,
    required: true,
  },
});


const PRIORITY_NAMES = {
  1: 'critical',
  2: 'high',
  3: 'medium',
  4: 'low',
};

const priorityName = computed(() => {
  if (typeof props.priority === 'number') {
    return PRIORITY_NAMES[props.priority] || 'medium';
  }
  return 'medium';
});


const PRIORITY_ICONS = {
  critical: 'fas fa-exclamation-triangle',
  high: 'fas fa-exclamation-circle',
  medium: 'fas fa-circle',
  low: 'far fa-circle',
};

const priorityIcon = computed(() => PRIORITY_ICONS[priorityName.value] || 'far fa-circle');


const componentClasses = computed(() => [
  'priority-icon',
  priorityName.value ? `is-${priorityName.value}` : '',
]);
</script>


<style scoped>
.priority-icon {
  display: flex;
  flex-shrink: 0;
  align-items: center;
  justify-content: center;

  &.is-critical {
    color: var(--stk-danger-50);
  }

  &.is-high {
    color: var(--stk-warning-60);
  }

  &.is-medium {
    color: var(--stk-info-60);
  }

  &.is-low {
    color: var(--stk-success-50);
  }
}
</style>
